<div class="relative mt-1 block w-full">
  <input #inputElement type="text"
    class="pl-3 pr-10 py-2 w-full text-base border border-gray-300 bg-whtie focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
    placeholder="Select a date" [disabled]="disabled">
  <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
    <lucide-icon name="calendar" class="h-5 w-5 text-gray-500"></lucide-icon>
  </div>
</div>
